import React from 'react';
import ReactDOM from 'react-dom';
import {MuiThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import './index.css';
import App from './App';
import Colors from './config/colors';

const theme = createMuiTheme({
    palette: {
        primary: {
            light: '#33ace2',
            main: Colors.primary,
            dark: '#006a99'
        },
        secondary: {
            light: '#e88e4e',
            main: Colors.secondary,
            dark: '#9e4f17',
        },
    },
    typography: {
        useNextVariants: true
    }
});

ReactDOM.render(
    <MuiThemeProvider theme={theme}>
        <App/>
    </MuiThemeProvider>,
    document.getElementById('root')
);